import { c as _c } from "react/compiler-runtime";
import Image, { StaticImageData } from 'next/image';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
interface QuoteProps {
  quote: string;
  testimonialPictureSrc: StaticImageData | string;
  description: string;
  status: string;
  variant?: 'step' | 'service';
}
const Quote = t0 => {
  const $ = _c(19);
  const {
    quote,
    testimonialPictureSrc,
    description,
    status,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "step" : t1;
  const t2 = variant === "step" ? "highlight" : "h5";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mb: 1
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== quote || $[2] !== t2) {
    t4 = <Typography variant={t2} component="p" sx={t3}>{quote}</Typography>;
    $[1] = quote;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== testimonialPictureSrc) {
    t5 = <Image src={testimonialPictureSrc} alt="" width={32} height={32} />;
    $[4] = testimonialPictureSrc;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== description) {
    t6 = <Typography variant="subheadingSmall" component="p">{description}</Typography>;
    $[6] = description;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== status) {
    t7 = <Typography variant="caption">{status}</Typography>;
    $[8] = status;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <Stack direction="row" alignItems="center" gap={1}>{t5}{t8}</Stack>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t9) {
    t10 = <div>{t4}{t9}</div>;
    $[16] = t4;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default Quote;